import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./Context/AuthContext"; // ← Make sure this path is correct
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,     // enables startTransition for better UX in navigation
        v7_relativeSplatPath: true,   // improves splat (*) route behavior (optional but recommended)
        v7_fetcherPersist: true,      // future-proof (persists fetcher state longer)
        v7_normalizeFormMethod: true, // normalizes form methods (GET/POST)
      }}
    >
      <AuthProvider>
        <Suspense fallback={<div className="loading-screen">Loading application...</div>}>
          <App />
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);